import React from "react";
import printPdf from "Utils/printPdf";

// Shared bits for the "Download as PDF" flows (seller profile, contact deep
// research). Kept together because the button and the print-only cover header
// are always used as a pair and share the same styling block.

/**
 * Top-right "Download as PDF" action. Hidden in the printed output itself via
 * `pdfNoPrint` — nobody wants a button rendered onto the page they just saved.
 */
const PdfDownloadButton = ({
  fileName = "",
  label = "Download as PDF",
  title = "Download this page as a PDF",
  disabled = false
}) => (
  <button
    type="button"
    className="pdfDownloadBtn pdfNoPrint"
    onClick={() => printPdf(fileName)}
    disabled={disabled}
    title={title}
  >
    {/* Filled `material-icons`, not the outlined variant: the outlined sheet
        loaded here is an older cut (v8 vs v47) and `file_download` is only
        proven against the filled set elsewhere in the app. */}
    <i className="material-icons pdfDownloadBtn__icon">picture_as_pdf</i>
    <span>{label}</span>
    <i className="material-icons pdfDownloadBtn__icon pdfDownloadBtn__icon--trail">
      file_download
    </i>
  </button>
);

/**
 * Cover header that exists only in the PDF. Screen users already have the page
 * title and context in the UI chrome; the printed copy loses all of that, so it
 * needs its own title, subject line and generation date to stand alone once it
 * has been forwarded to someone else.
 */
const PdfPrintHeader = ({ title = "", subtitle = "" }) => (
  <header className="pdfPrintOnly pdfDocHeader">
    <h1 className="pdfDocHeader__title">{title}</h1>
    {subtitle && <p className="pdfDocHeader__subtitle">{subtitle}</p>}
    <p className="pdfDocHeader__meta">
      Generated {new Date().toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric"
      })}
    </p>
  </header>
);

export { PdfDownloadButton, PdfPrintHeader };
